
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import { ModalSlotName } from '@/ui-kit/components/modal/enums';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Button from '@/ui-kit/components/button';
import IconButton from '@/ui-kit/components/icon-button';
import Icon from '@/ui-kit/components/icon';
import { StyleColorSchemeType, StyleSizeType, StylePositionType } from '@/ui-kit/styles/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import Gutter from '@/ui-kit/components/gutter';
import ListingsApiService from '@/services/api/listings';
import routes from '@/constants/routes';
import { LISTING_ORIGIN_TYPES, LISTING_TRACK_EVENT_ORIGIN_TYPES } from '@/constants';
import ExternalNavigationHelper from '@/utils/external-navigation';
import { track } from '@/utils/analytics';
import NavigatorService from '@/services/Navigator';
import ToastService from '@/components/toast/toast-service';
import ShareListingModalForm from './form';
import { SOCIAL_BUTTONS_CONFIG, MODAL_COPY } from './constants';

export default {
  name: 'ShareListingModal',
  components: {
    ModalWindow,
    Typography,
    Button,
    IconButton,
    Icon,
    Gutter,
    ShareListingModalForm,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      ModalSlotName,
      TypographyType,
      StyleColorSchemeType,
      StyleSizeType,
      StylePositionType,
      IconType,
      ButtonFillType,
      SOCIAL_BUTTONS_CONFIG,
      isLoading: false,
    };
  },
  computed: {
    listing() {
      return this.modalData.listing;
    },
    listingId() {
      return this.listing.listingId;
    },
    listingUrl() {
      return `${window.location.origin}${routes.listings}/${this.listingId}`;
    },
    title() {
      return this.modalData.title || MODAL_COPY.title;
    },
    socialShareCopy() {
      return this.modalData.socialShareCopy || MODAL_COPY.socialShare;
    },
    trackOrigin() {
      return this.listing.isBode
        ? LISTING_TRACK_EVENT_ORIGIN_TYPES.Bode
        : LISTING_TRACK_EVENT_ORIGIN_TYPES.MLS;
    },
    shareListingUrl() {
      return this.listing?.shareUrl || this.listingUrl;
    },
  },
  methods: {
    async handleFormSubmit(recipient) {
      this.isLoading = true;
      await ListingsApiService.shareListingByEmail(this.listingId, {
        ...recipient,
        listingUrl: this.shareListingUrl,
      });
      await this.finalizeSharing('email');
      ToastService.openPositive('Share Successful');
    },
    async handleSocialShareClick({ shareBaseUrl, name }) {
      ExternalNavigationHelper.openInNewWindow(`${shareBaseUrl}${this.listingUrl}`);
      await this.finalizeSharing(name);
    },
    async handleShareLinkClick() {
      await NavigatorService.copyToClipboard(this.shareListingUrl);
      await this.finalizeSharing('link');
      ToastService.openPositive('The link has been copied. You can now paste it anywhere you like.');
    },
    async finalizeSharing(shareSourceName) {
      this.trackListingShared(shareSourceName);
      this.closeHandler(await this.addShareCount());
    },
    addShareCount() {
      return ListingsApiService.countShareListing(this.listingId);
    },
    trackListingShared(source) {
      const isSoldProperty = window.location.pathname.includes(routes.soldProperty);
      const eventName = `${this.trackOrigin}${isSoldProperty ? '_Sold Property' : '_Listing'} shared by ${source}`;
      const properties = {
        listingId: this.listingId,
        category: 'Listing Engagement',
        eventlabel: `Listing Engagement - ${this.trackOrigin} Listing Shared`,
        listingType: LISTING_ORIGIN_TYPES[this.listing.origin] || this.listing.origin,
      };

      return track(eventName, properties);
    },
  },
};
